var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTextGlitch',{attrs:{"fill":"#d1d5db","text":_vm.text,"background":"","highlight2":"cyan"}})
}
var staticRenderFns = []

export { render, staticRenderFns }